import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "hidden",
})
export class HiddenPipe implements PipeTransform {
  transform(items: any[]): any[] {
    return items.filter((item) => !item.hidden);
  }
}
